export const DEFAULT_FILTERS = {
  search: "",
  presence: "all",
  gender: "all",
  discipline: "all",
  club: "all",
  ageCategories: [],
  weightCategories: [],
  years: [],
};

export const PER_PAGE_OPTIONS = [25, 50, 100, 200];

export const AGE_CATEGORY_ORDER = [
  "Éveil",
  "Mini-Poussin(e)",
  "Poussin(e)",
  "Benjamin(e)",
  "Minime",
  "Cadet(te)",
  "Junior",
  "Sénior",
  "Vétéran",
  "U7",
  "U9",
  "U10",
  "U11",
  "U12",
  "U13",
  "U14",
  "U15",
  "U16",
  "U18",
  "U21",
];

export const WEIGHT_EXCLUDED_LABELS = [
  "Non pesé(e)",
  "Poids invalide",
  "Catégorie d'âge inconnue",
];

export const ALL_DISCIPLINES = [
  "Judo",
  "Ne-Waza",
  "JJB",
  "Jujitsu Combat",
  "Jujitsu Duo",
  "Arbitre",
  "Commissaire Sportif",
  "Judo Adapté"
];

export const GRADE_OPTIONS = [
  { label: "Ceinture blanche", value: "blanche" },
  { label: "Ceinture blanche 1 liseré", value: "blanche 1 liseré" },
  { label: "Ceinture blanche 2 liserés", value: "blanche 2 liserés" },
  { label: "Ceinture blanche-jaune", value: "blanche-jaune" },
  { label: "Ceinture jaune", value: "jaune" },
  { label: "Ceinture jaune-orange", value: "jaune-orange" },
  { label: "Ceinture orange", value: "orange" },
  { label: "Ceinture orange-verte", value: "orange-verte" },
  { label: "Ceinture verte", value: "verte" },
  { label: "Ceinture verte-bleue", value: "verte-bleue" },
  { label: "Ceinture bleue", value: "bleue" },
  { label: "Ceinture bleue-marron", value: "bleue-marron" },
  { label: "Ceinture marron", value: "marron" },
  { label: "1er Dan", value: "1er Dan" },
  { label: "2e Dan", value: "2e Dan" },
  { label: "3e Dan", value: "3e Dan" },
  { label: "4e Dan", value: "4e Dan" },
  { label: "5e Dan", value: "5e Dan" },
];